import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EventsRepository } from '../repositories/events.repository';
import { map } from 'rxjs/operators';
import {
	IEventDetail,
	IEventList,
	IEventRegistered,
	IEventRegistrationDetail,
	IRequestGetEvents,
	IRequestGetEventsByPublisher
} from '../../data/interface/events.interface';

@Injectable({
	providedIn: 'root'
})
export class EventsUsecase {
	constructor(private eventsReporitory: EventsRepository) {}

	getAllEvents(params: IRequestGetEvents): Observable<any> {
		return this.eventsReporitory.getAllEvents(params).pipe(
			map((result: any) => {
				if (result.data) {
					return result.data;
				} else {
					return [];
				}
			})
		);
	}

	getAllEventRegistered(): Observable<IEventList[]> {
		return this.eventsReporitory.getAllRegisteredEvents().pipe(
			map((result: any) => {
				if (result.data) {
					return result.data.map((item: IEventRegistered) => {
						return {
							...item.event,
							submittedPost: item.submittedPost
						};
					});
				} else {
					return [];
				}
			})
		);
	}

	getAllProfileEvents(username: string): Observable<IEventList[]> {
		return this.eventsReporitory.getAllProfileEvents(username).pipe(
			map((result: any) => {
				if (result.data) {
					return result.data.map((item: IEventRegistered) => {
						return {
							...item.event,
							submittedPost: item.submittedPost
						};
					});
				} else {
					return [];
				}
			})
		);
	}

	getEventsByUrl(url: string): Observable<IEventDetail> {
		return this.eventsReporitory.getEventsByUrl(url).pipe(
			map((result: any) => {
				if (result.data) {
					return result.data;
				} else {
					return [];
				}
			})
		);
	}

	registerEvent(params: object, id: string): Observable<any> {
		return this.eventsReporitory.registerEvent(params, id).pipe(
			map((result: any) => {
				if (result) {
					return result;
				} else {
					return [];
				}
			})
		);
	}

	checkStatusEvent(id: string): Observable<boolean> {
		return this.eventsReporitory.checkStatusEvent(id).pipe(
			map((result: any) => {
				return result.data.isRegistered;
			})
		);
	}

	checkEventSubmissionStatus(id: string): Observable<boolean> {
		return this.eventsReporitory.checkEventSubmissionStatus(id).pipe(
			map((result: any) => {
				return result.data.isPostSubmitted;
			})
		);
	}

	getEventRegistrationDetail(id: string): Observable<IEventRegistrationDetail> {
		return this.eventsReporitory.getDetailRegistration(id).pipe(
			map((result: any) => {
				return result.data;
			})
		);
	}

	submitEvent(id: string, postId: string): Observable<any> {
		return this.eventsReporitory.submitEvent(id, postId).pipe(
			map((result: any) => {
				if (result) {
					return result;
				} else {
					return [];
				}
			})
		);
	}

	submitPaymentEvent(eventId: string): Observable<any> {
		const payload = {
			eventId
		};
		return this.eventsReporitory.submitPaymentEvent(payload).pipe(
			map((response: any) => {
				return response.data;
			})
		);
	}

	getListEventsByPublisher(
		params: IRequestGetEventsByPublisher,
		publisherId: string
	): Observable<any> {
		return this.eventsReporitory.getListEventsByPublisher(params, publisherId).pipe(
			map((result: any) => {
				if (result.data) {
					return result.data;
				} else {
					return [];
				}
			})
		);
	}
}
